/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema } from '../schema';
import { Data3, data3Schema } from './data3';
import { Links, linksSchema } from './links';
import { Meta, metaSchema } from './meta';

export interface AC102Retrievebulkbalances {
  data: Data3;
  links: Links;
  meta: Meta;
}

export const aC102RetrievebulkbalancesSchema: Schema<AC102Retrievebulkbalances> = object(
  {
    data: ['Data', lazy(() => data3Schema)],
    links: ['Links', lazy(() => linksSchema)],
    meta: ['Meta', lazy(() => metaSchema)],
  }
);
